/** Production Cognito callbacks are registered on Railway only. */
export function ssoBackendOrigin(apiBaseUrl: string): string {
  if (typeof window !== 'undefined' && /(^|\.)tripnovac-visa\.com$/i.test(window.location.hostname)) {
    return 'https://tripnovac-visa-production.up.railway.app';
  }
  return String(apiBaseUrl || '').replace(/\/api\/?$/, '');
}
